/* eslint-disable no-nested-ternary */
import {
  Dialog,
  Grid,
  IconButton,
  makeStyles,
  Slide,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Image from "next/image";
import * as React from "react";
import FileDialog from "../../../../common/file/FileDialog";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiPaper-root": {
      borderRadius: "21px !important",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
      "&::-webkit-scrollbar": {
        width: "10px",
        height: "13px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#ededed",
        borderRadius: "50px",
      },
      "&::-webkit-scrollbar-thumb": {
        height: "6px",
        border: "4px solid rgba(0, 0, 0, 0)",
        backgroundClip: "padding-box",
        backgroundColor: "#8898aa",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#525b67",
      },
    },
  },
  closeIcon: {
    fontSize: "1.818rem",
  },
  container: {
    width: "700px",
    minHeight: "300px",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  header: {
    height: "100px",
    borderBottom: "2px solid #ededed",
  },
  title: {
    // textAlign: 'left',
    marginRight: "16.67%",
    fontWeight: "bold",
    color: "#000000d9",
    [theme.breakpoints.down("md")]: {
      fontSize: "1.3rem !important",
    },
  },
  singleDocument: {
    position: "relative",
    maxWidth: "100%",
    flexBasis: "100%",
    margin: "1%",
    aspectRatio: 1,
    border: "1px solid #ededed",
    borderRadius: "6px",
    textAlign: "center",
    backgroundColor: "rgba(173, 173, 173, 0.36)",
    "& img": {
      width: "auto",
      height: "auto",
      position: "absolute",
      maxWidth: "100%",
      maxHeight: "100%",
      margin: "auto",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
    "&:hover": {
      cursor: "pointer",
    },
  },
  filesContainer: {
    padding: "10px",
  },
  default404: {
    position: "absolute",
    marginTop: "calc(50% - 33.5px)",
    textAlign: "center",
    width: "100%",
    fontSize: "4rem !important",
    fontWeight: "bold",
    color: "#cacaca",
  },
  otherFiles: {
    textAlign: "center",
    fontWeight: "bold",
    marginTop: "calc(50% - 2rem)",
    fontSize: "4rem !important",
    opacity: "0.1",
    userSelect: "none",
  },
}));

const FolderDialog = ({ open, setActiveFolder, folder, ...props }) => {
  const classes = useStyles();
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [showFile, setShowFile] = React.useState(false);

  const handleClose = () => {
    setActiveFolder(null);
  };

  const handleFileOpen = (file) => {
    setSelectedFile(file);
    setShowFile(true);
  };

  return (
    <FileDialog file={folder} open={folder} setOpen={handleClose} />
    // <Dialog
    //   open={folder}
    //   TransitionComponent={Transition}
    //   keepMounted
    //   scroll="paper"
    //   maxWidth="xl"
    //   onClose={handleClose}
    //   className={classes.root}
    // >
    //   <Grid container className={classes.container}>
    //     <Grid
    //       item
    //       container
    //       xs={12}
    //       sm={12}
    //       md={12}
    //       justify="flex-start"
    //       alignItems="center"
    //       className={classes.header}
    //     >
    //       <Grid item xs={2} sm={2} md={2}>
    //         <IconButton onClick={handleClose}>
    //           <CloseIcon className={classes.closeIcon} />
    //         </IconButton>
    //       </Grid>
    //       <Grid item xs={10} sm={10} md={10} />
    //     </Grid>
    //     <Grid
    //       item
    //       container
    //       xs={12}
    //       sm={12}
    //       md={12}
    //       className={classes.filesContainer}
    //     >
    //       {Array.isArray(folder) ? (
    //         folder?.map((item) =>
    //           item?.files?.map((singleFile) => (
    //             <Grid
    //               item
    //               xs
    //               sm
    //               md
    //               key={singleFile?.url}
    //               onClick={() => handleFileOpen(singleFile?.url)}
    //               className={classes.singleDocument}
    //             >
    //               {singleFile?.url.includes(".pdf") ||
    //               singleFile?.url.endsWith(".xlsx") ||
    //               singleFile?.url.endsWith(".word") ? (
    //                 <Typography variant="h4" className={classes.default404}>
    //                   {singleFile?.url
    //                     .split(".")
    //                     [singleFile?.url.split(".").length - 1].toUpperCase()}
    //                 </Typography>
    //               ) : (
    //                 <Image
    //                   placeholder="blur"
    //                   blurDataURL={singleFile?.url}
    //                   src={singleFile?.url}
    //                   alt="test"
    //                   width={100}
    //                   height={100}
    //                   layout="responsive"
    //                   // layout="fill"
    //                 />
    //               )}
    //             </Grid>
    //           ))
    //         )
    //       ) : typeof folder === "object" ? (
    //         folder?.files?.map((singleFile) => (
    //           <Grid
    //             item
    //             xs
    //             sm
    //             md
    //             key={singleFile?.url}
    //             onClick={() => handleFileOpen(singleFile?.url)}
    //             className={classes.singleDocument}
    //           >
    //             {singleFile?.url.endsWith(".pdf") ||
    //             singleFile?.url.endsWith(".xlsx") ||
    //             singleFile?.url.endsWith(".word") ? (
    //               <Typography className={classes.otherFiles}>PDF</Typography>
    //             ) : (
    //               <Image
    //                 placeholder="blur"
    //                 blurDataURL={singleFile?.url}
    //                 src={singleFile?.url}
    //                 // layout="fill"
    //                 alt="test"
    //                 width={100}
    //                 height={100}
    //                 layout="responsive"
    //               />
    //             )}
    //           </Grid>
    //         ))
    //       ) : (
    //         <Grid
    //           item
    //           xs
    //           sm
    //           md
    //           className={classes.singleDocument}
    //           onClick={() => handleFileOpen(folder)}
    //         >
    //           {folder && (
    //             <Image
    //               width={100}
    //               height={100}
    //               src={folder}
    //               blurDataURL={folder}
    //               layout="responsive"
    //               placeholder="blur"
    //               alt="test"
    //             />
    //           )}
    //         </Grid>
    //       )}
    //     </Grid>
    //   </Grid>
    // </Dialog>
  );
};

export default FolderDialog;
